import React from 'react';
import axios from 'axios';
import {
    fetchAllAcademicYears,
    fetchFaculties,
    fetchLanguages,
    fetchStudyCycle,
    fetchTitles
} from '../../Lookups/util';
import NewStudyProgram from './NewStudyProgram';

axios.defaults.xsrfHeaderName = "X-XSRF-TOKEN";
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
//axios.defaults.crossDomain = true;

class CreateStudyProgramImplementation extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            orgUnits: [],
            studyCycles: [],
            languages: [],
            academicYears: [],
            studyCyclesDropdown: [],
            languagesDropdown: [],
            academicYearsDropdown: [],
            titles: [],
        };
    }

    componentDidMount() {
        axios.all([fetchFaculties(), fetchStudyCycle(), fetchLanguages(), fetchAllAcademicYears(), fetchTitles()])
            .then(axios.spread((orgUnitsRes, studyCycleRes, languageRes, academicYearsRes, titlesRes) => {
                const orgUnits = orgUnitsRes.data.map(el => ({
                    key: el.id, value: el.id, text: el.name
                }));
                const studyCyclesDropdown = studyCycleRes.data.map(el => ({
                    key: el.id, value: el.id, text: el.displayName
                }));
                const languagesDropdown = languageRes.data.map(el => ({
                    key: el.id, value: el.id, text: el.name
                }));
                const academicYearsDropdown = academicYearsRes.data.map(el => ({
                    key: el.id, value: el.id, text: el.name
                }));
                const titles = titlesRes.data.map(el => ({
                    key: el.id, value: el.id, text: el.name
                }));
                const studyCycles = studyCycleRes.data;
                const languages = languageRes.data;
                const academicYears = academicYearsRes.data;

                this.setState({
                    orgUnits,
                    studyCycles,
                    languages,
                    academicYears,
                    studyCyclesDropdown,
                    languagesDropdown,
                    academicYearsDropdown,
                    titles
                });
            }))
            .catch(err => {
                this.setState({ error: true });
                console.log('Failed to fetch org. units');
            });
    }


    render() {
        return (
            <div>
                <NewStudyProgram
                    orgUnits={this.state.orgUnits}
                    languages={this.state.languages}
                    studyCycles={this.state.studyCycles}
                    titles={this.state.titles}
                    academicYears={this.state.academicYears}
                    languagesDropdown={this.state.languagesDropdown}
                    studyCyclesDropdown={this.state.studyCyclesDropdown}
                    academicYearsDropdown={this.state.academicYearsDropdown.reverse()}
                />
            </div>
        );
    }
}

export default CreateStudyProgramImplementation;



// WEBPACK FOOTER //
// ./src/views/Admin/CreateStudyProgramImplementation/CreateStudyProgramImplementation.js